<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <div class="flex justify-content-between align-items-center">
                    <h3>Check In Patroli</h3>
                </div>
                <div
                    class="flex align-items-center flex-column col-lg-12 mx-auto"
                >
                    <qrcode-stream
                        :track="paintBoundingBox"
                        @detect="onDetect"
                        @error="logErrors"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import AppLayout from "../../Layouts/AppLayout.vue";
import axios from "axios";
import FlashMessage from "../../Services/FlashMessage";

export default {
    layout: AppLayout,
    components: { QrcodeStream },
    mixins: [FlashMessage],
    data() {
        return {};
    },

    methods: {
        onDetect(detectedCodes) {
            const data = detectedCodes[0].rawValue;

            let formData = new FormData();
            formData.append('patrol_point_id', data);

            axios
            .post(`${this.$page.props.appUrl}api/patrol-checkins`, formData)
            .then((response) => {
                this.flashSuccess('Patrol Checkin Created')
                window.location.href = `${this.$page.props.appUrl}patrol-checkin-history`;
            })
            .catch((error) => {
                this.flashError('Patrol Checkin Not Created')
            });
        },
        paintBoundingBox(detectedCodes, ctx) {
            for (const detectedCode of detectedCodes) {
                const {
                    boundingBox: { x, y, width, height },
                } = detectedCode;

                ctx.lineWidth = 2;
                ctx.strokeStyle = "#007bff";
                ctx.strokeRect(x, y, width, height);
            }
        },

        logErrors: console.error,
    },
};
</script>
